import { render, staticRenderFns } from "./DashboardStat.vue?vue&type=template&id=11980c0f&functional=true"
import script from "./DashboardStat.vue?vue&type=script&lang=js"
export * from "./DashboardStat.vue?vue&type=script&lang=js"
import style0 from "./DashboardStat.vue?vue&type=style&index=0&id=11980c0f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports